import { useContext } from "react";

import { AccordionContext } from "../../Accordion";

export function useAccordion() {
  const context = useContext(AccordionContext);

  if (!context) {
    throw new Error(
      "useAccordion should be used within the AccordionProvider provider."
    );
  }

  return context;
}
